<template>
  <mia-wait :for="['website.sites', `website.sites.${siteId}`]">
    <template #waiting>
      <div class="flex justify-center">
        <mia-wave-loader />
      </div>
    </template>

    <div
      v-if="site"
      class="px-4"
    >
      <div class="flex items-center mt-4">
        <div>
          <button
            class="text-gray-600 transition-colors duration-150 hover:text-gray-800"
            type="button"
            @click="$router.push({ name: 'website-site', params: { siteId } })"
          >
            <mia-streamline-icon
              class="w-10 h-10 fill-current"
              src="navigation-left-circle-1_1"
            />
          </button>
        </div>
        <h1
          class="p-0 m-0 ml-4"
          v-text="`Seiteneinstellungen von ${site.domain} bearbeiten`"
        />
      </div>

      <mia-website-site-form
        v-model="form"
        class="mt-8 -mx-4"
        :site-id="siteId"
        @validation-changed="isValid = $event"
      />

      <div class="flex justify-end py-8">
        <mia-button
          class="px-4 py-2 hover:bg-gray-400"
          type="button"
          @click="$router.push({ name: 'website-site', params: { siteId } })"
        >
          Abbrechen
        </mia-button>

        <mia-loading-button
          class="px-4 py-2 ml-4 text-white bg-blue-500 hover:bg-blue-600"
          :disabled="!isValid"
          :is-loading="$wait.is('updating site')"
          type="button"
          @click="submit"
        >
          Änderungen speichern
        </mia-loading-button>
      </div>
    </div>
  </mia-wait>
</template>

<script>
import get from 'lodash/get'
import { mapState } from 'vuex'
import SiteForm from '@/components/website/SiteForm.vue'
import { WEBSITE_LOAD_SITES } from '@/store/action-types'
import { WEBSITE_UPDATE_SITE } from '@/store/mutation-types'
import Website from '@/api/website'

export default {
  name: 'MiaWebsiteSiteSettings',

  components: {
    'mia-website-site-form': SiteForm
  },

  data() {
    return {
      isValid: false,
      form: {
        domain: '',
        title: '',
        theme_id: '',
        address: '',
        register: '',
        court: '',
        legal_persons: '',
        tax_id: '',
        phone: '',
        fax: '',
        email: '',
        responsible_person: '',
        google_tracking_id: '',
        google_tracking_enabled: false,
        google_tag_manager_id: '',
        google_tag_manager_enabled: false
      }
    }
  },

  computed: {
    ...mapState({
      site(state) {
        return state.website.sites.find(s => s.id === parseInt(this.$route.params.siteId, 10))
      }
    }),

    siteId() {
      return parseInt(this.$route.params.siteId, 10)
    }
  },

  watch: {
    site: {
      immediate: true,
      handler(site) {
        if (site) {
          this.form.domain = site.domain
          this.form.title = site.title
          this.form.theme_id = site.theme_id
          this.form.address = site.address
          this.form.register = site.register
          this.form.court = site.court
          this.form.legal_persons = site.legal_persons
          this.form.tax_id = site.tax_id
          this.form.phone = site.phone
          this.form.fax = site.fax
          this.form.email = site.email
          this.form.responsible_person = site.responsible_person
          this.form.google_tracking_id = site.google_tracking_id
          this.form.google_tracking_enabled = site.google_tracking_enabled
          this.form.google_tag_manager_id = site.google_tag_manager_id
          this.form.google_tag_manager_enabled = site.google_tag_manager_enabled
        }
      }
    }
  },

  async created() {
    await this.$store.dispatch(WEBSITE_LOAD_SITES)

    if (!this.site) {
      this.$router.replace('/404')
    }
  },

  methods: {
    async submit() {
      this.$wait.start('updating site')

      try {
        const data = await Website.updateSiteSettings(this.siteId, this.form)

        this.$store.commit(WEBSITE_UPDATE_SITE, { data, siteId: this.siteId })

        eventBus.$emit('mia-info', {
          info: ['Die Seiteneinstellungen wurden erfolgreich aktualisiert.']
        })
      } catch (e) {
        const message = get(e, 'response.data.message', 'Die Seiteneinstellungen konnten nicht aktualisiert werden.')

        eventBus.$emit('mia-error', {
          error: [message]
        })
      } finally {
        this.$wait.end('updating site')
      }
    }
  }
}
</script>
